import { openDB } from 'idb';

const DB_NAME = 'mogym-offline-db';
const DB_VERSION = 1;
const STORE_NAME = 'plans';

async function getDb() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'planId' });
      }
    },
  });
}

export async function savePlanOffline(planId, data) {
  if (!planId || !data) return;

  const db = await getDb();

  await db.put(STORE_NAME, {
    planId: String(planId),
    data,
    savedAt: new Date().toISOString(),
  });
}

export async function getPlanOffline(planId) {
  if (!planId) return null;

  const db = await getDb();
  return db.get(STORE_NAME, String(planId));
}